import client from '../config/axios';

const notionService = {
  getPageContent: async (pageId) => {
    try {
      const response = await client.get(`/notion/page/${pageId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener datos de Notion:', error);
      throw error;
    }
  }
};

export default notionService;